import type { WpMedia } from '~/composables/use-wp/api/media';

export interface VoteNowModal {
  body: string;
  image: WpMedia;
  link: {
    title: string;
    url: string;
    target: string;
  };
}

export const useOptionsStore = defineStore('options', {
  state: () => ({
    voteNowModal: null as VoteNowModal | null,
    optionsFetched: false
  }),

  getters: {
  },

  actions: {
    async fetchAll() {
      if (this.optionsFetched) {
        return;
      }

      const wp = useWp();

      const options = await wp.options.get<{ vote_now_modal: VoteNowModal }>(['vote_now_modal']);

      this.voteNowModal = options.vote_now_modal;
      this.optionsFetched = true;
    }
  }
});
